import React from 'react'
import { View, Image, TouchableOpacity } from 'react-native'
import theme from '../../../theme'
import FlatLabels from './FlatLabels'
import styles from './PostFlagsStyles'
import FontAwesome from '@expo/vector-icons/FontAwesome'
import { PostTagsTheme } from '../../../themeConstants'

const PostFlags = ({ posts, onSelectLabel, onPressFavourite, extraStyle }) => (
    <View style={styles.container}>
        {posts.isFavourite ? (
            <TouchableOpacity onPress={() => onPressFavourite(posts._id)}>
                {posts.isSelected ? (
                    <FontAwesome name='bookmark' size={26} color={PostTagsTheme.tagSelectedColor} style={styles.bookmark} />
                ) : (
                    <FontAwesome name='bookmark-o' size={26} color={PostTagsTheme.tagSelectedColor} style={styles.bookmark} />
                )}
            </TouchableOpacity>
        ) : (
            <FlatLabels posts={posts} onSelectLabel={onSelectLabel} extraStyle={extraStyle} />
        )}
    </View>
)

export default PostFlags
